import { Tooltip as RechartsTooltip } from 'recharts';
const ChartTooltip = RechartsTooltip;
// biome-ignore lint/suspicious/noExplicitAny: <explanation>
export const defaultFormatter = (dataUnit) => (value) => `${value} ${dataUnit}`;
export default ChartTooltip;
